import React from 'react'

export default function TelegramIcon() {
    return (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_7_27)">
                <path d="M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z" fill="#039BE5" />
                <path d="M7.77892 16.6317L24.1698 10.312C24.9305 10.0371 25.5949 10.4976 25.3484 11.6479L25.3498 11.6465L22.559 24.7946C22.3522 25.7267 21.7983 25.9534 21.0233 25.5142L16.7733 22.382L14.7234 24.3568C14.4968 24.5835 14.3055 24.7747 13.8663 24.7747L14.1681 20.4496L22.0448 13.3337C22.3876 13.032 21.9683 12.862 21.5163 13.1623L11.7824 19.2908L7.58626 17.9818C6.67534 17.6928 6.65551 17.0709 7.77892 16.6317Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_7_27">
                    <rect width="34" height="34" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
